<app-list-of-contracts [contractList]="signalContractList()"
    (contractEmitter)="getEvents($event)"></app-list-of-contracts>